/**
 * Logger utility for consistent logging across the application.
 * Suppresses debug and info logs in production environments.
 */

const isProduction = import.meta.env.PROD;

const logger = {
    debug: (...args: any[]) => {
        if (!isProduction) {
            console.log(...args);
        }
    },
    info: (...args: any[]) => {
        if (!isProduction) {
            console.info(...args);
        }
    },
    warn: (...args: any[]) => {
        console.warn(...args);
    },
    error: (...args: any[]) => {
        console.error(...args);
    },
};

export default logger;
